import React, { type ReactNode } from "react";
import { Box, Paper } from "@mui/material";
import { adminSurface } from "../../styles/adminUiTokens";

interface AdminFilterBarProps {
  search?: ReactNode;
  filters?: ReactNode;
  actions?: ReactNode;
  /** Wrap filters in a bordered toolbar panel */
  bordered?: boolean;
}

const AdminFilterBar: React.FC<AdminFilterBarProps> = ({
  search,
  filters,
  actions,
  bordered = true,
}) => {
  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        width: "100%",
      }}
    >
      {search}
      {(filters || actions) && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "flex-end",
            gap: 1.5,
            width: "100%",
          }}
        >
          {filters}
          {actions && (
            <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>{actions}</Box>
          )}
        </Box>
      )}
    </Box>
  );

  if (!bordered) {
    return content;
  }

  return (
    <Paper elevation={0} sx={{ ...adminSurface, p: { xs: 1.5, sm: 2 }, mb: 2 }}>
      {content}
    </Paper>
  );
};

export default AdminFilterBar;
